
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { bookPackageKeys, MODE } from '../../../data/queryFactories'
import BookPackageFormModal from './BookPackageFormModal'
import { bookCollectionService } from '../../../service/BookCollectionService'
import { showErrorToast, showLoadingToast, showSuccessToast, toastKey } from '../../../utils/showToast'
import { useModal } from '../../../context/ModalProvider'


export default function CreateBookPackageModal() {
  const queryClient = useQueryClient()
  const {handleCloseModal}= useModal()
  const addBookPackageMutation = useMutation({
    mutationFn: async (bookPackage) => {
      const { success, message } = await bookCollectionService.create({
        name: bookPackage.name,
      })
      if (!success) {
        throw new Error(message.content)
      }
      return { success, message }
    },
    onMutate: () => {
      showLoadingToast('Đang tạo gói sách', toastKey.BOOKS_MANAGEMENT.PACKAGE.LIST.GET)
    },
    onError: (error) => {
      showErrorToast({
        message: error.message || 'Tạo gói sách thất bại',
        toastId: toastKey.BOOKS_MANAGEMENT.PACKAGE.LIST.GET,
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: bookPackageKeys.all })
      showSuccessToast(
        'Thêm gói sách thành công',
        toastKey.BOOKS_MANAGEMENT.PACKAGE.LIST.GET
      )
      handleCloseModal()
    },
  })

  return (
    <BookPackageFormModal
      mode={MODE.CREATE}
      initForm={{
        name: '',
      }}
      submitHandler={(formData) => {
        addBookPackageMutation.mutate(formData)
      }}
      isLoading={addBookPackageMutation.isPending}
    />
  )
}